/* eslint-disable react/prop-types */
import React from 'react';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, InputGroup } from 'react-bootstrap';

const AnswerItem = ({
  answer,
  index,
  hiddenAnswer,
  onAnswerChange,
  handleToggleHidden,
  onDirty,
  draggableProvided,
}) => {
  return (
    <InputGroup
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      {...draggableProvided.dragHandleProps}
    >
      <InputGroup.Text className="dragable" onClick={() => handleToggleHidden(answer)}>
        <img src="/drag_drop_icon.png" alt="Bento Logo" />
      </InputGroup.Text>
      <Form.Control
        className="mt-3"
        id={answer.id}
        value={answer.value}
        disabled={hiddenAnswer}
        type="text"
        onChange={(e) => onAnswerChange(e, index)}
        onBlur={onDirty}
      />
      <InputGroup.Text className="text-eye" onClick={() => handleToggleHidden(answer)}>
        {!hiddenAnswer && <FontAwesomeIcon className="eye-icon mt-3" size="1x" icon={faEye} />}
        {hiddenAnswer && <FontAwesomeIcon className="eye-icon mt-3" size="1x" icon={faEyeSlash} />}
      </InputGroup.Text>
    </InputGroup>
  );
};

export default AnswerItem;
